import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-share-update-email',
    templateUrl: './share-update-email.component.html',
    styleUrls: ['./share-update-email.component.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class ShareUpdateEmailComponent {
	constructor(
		private _notificationService: NotificationService,
		public _fundraiserService: FundraiserService,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			fundraiserId: any;
			slug: string;
			updateId: any;
			locale: any;
		},
		public dialogRef: MatDialogRef<ShareUpdateEmailComponent>
	) {}

	sendUpdateEmail() {
		this._fundraiserService.shareUpdates(this.data).subscribe((res) => {
			this._notificationService.openNotification(
				$localize`:@@share_update_email_notification:Email has been sent to all donors`,
				'OK',
				'success'
			);
			this.dialogRef.close();
		},
		(error) => {
			this._notificationService.openNotification(
			  $localize`:@@share_update_email_error:An error occurred while sending the email to donors`,
			  'OK',
			  'error'
			);
	
		});
	}

	onCloseClick() {
		this.dialogRef.close();
	}
}
